import { createSlice, createDraftSafeSelector, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchSaveUserInfo = createAsyncThunk('user/fetchSaveUserInfo', async data => {
  try {
    const { eventCode, customerKey, eventKey } = data;
    return { eventCode, customerKey, eventKey };
  } catch (err) {
    throw err.response?.data?.error || err;
  }
});

const initialState = {
  loading: 'idle',
  actionResult: '',
  user: {},
  error: '',
};

const reducers = {};

const extraReducers = {
  [fetchSaveUserInfo.pending]: state => {
    if (state.loading === 'idle') {
      state.loading = 'pending';
      state.actionResult = 'REQ';
    }
  },
  [fetchSaveUserInfo.fulfilled]: (state, action) => {
    if (state.loading === 'pending') {
      state.loading = 'idle';
      state.actionResult = 'SUCCESS';
      state.user = action.payload;
      state.error = '';
    }
  },
  [fetchSaveUserInfo.rejected]: (state, action) => {
    if (state.loading === 'pending') {
      state.loading = 'idle';
      state.actionResult = 'FAILURE';
      state.user = {};
      state.error = action.error;
    }
  },
};

export const user = createSlice({
  name: 'user',
  initialState,
  reducers: reducers,
  extraReducers: extraReducers,
});

export const USER = user.name;
export const userReducer = user.reducer; /* reducer */

/* create selector */
const selectUserInfo = createDraftSafeSelector(
  state => state.user,
  state => state.actionResult,
  state => state.loading,
  state => state.error,
  (user, actionResult, loading, error) => ({
    user,
    actionResult,
    loading,
    error,
  })
);

export const userSelector = {
  userInfoState: state => selectUserInfo(state[USER]),
};
